export const convertToEmbedUrl = (url: string): string => {
  if (!url) return "";

  // YouTube URL patterns
  const youtubeRegex =
    /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
  const youtubeMatch = url.match(youtubeRegex);

  if (youtubeMatch) {
    const videoId = youtubeMatch[1];
    return `https://www.youtube.com/embed/${videoId}`;
  }

  // Vimeo URL patterns
  const vimeoRegex = /(?:vimeo\.com\/)([0-9]+)/;
  const vimeoMatch = url.match(vimeoRegex);

  if (vimeoMatch) {
    const videoId = vimeoMatch[1];
    return `https://player.vimeo.com/video/${videoId}`;
  }

  // If it's already an embed URL or direct video file, return as is
  return url;
};

export const isVideoUrl = (url: string): boolean => {
  if (!url) return false;

  // Check for common video file extensions
  const videoExtensions = /\.(mp4|webm|ogg|avi|mov)$/i;
  if (videoExtensions.test(url)) return true;

  // Check for YouTube or Vimeo URLs
  const youtubeRegex = /(?:youtube\.com|youtu\.be)/;
  const vimeoRegex = /vimeo\.com/;

  return youtubeRegex.test(url) || vimeoRegex.test(url);
};

export const getVideoDimensions = (file: File): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const objectUrl = URL.createObjectURL(file);
    video.preload = "metadata";
    video.src = objectUrl;
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ width: video.videoWidth || 0, height: video.videoHeight || 0 });
    };
    video.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to read video metadata"));
    };
  });
};
